import React from 'react';
import './PC.css';
import Bardavelidze from '../../img/PC/Bardavelidze.png'
import Hull from '../../img/PC/Hull.png'
import Dimitrov from '../../img/PC/Dimitrov.png'
import Kuzovkin from '../../img/PC/Kuzovkin.png'
import Peter from '../../img/PC/Peter.png'
import Gareth from '../../img/PC/Gareth.png'

export default class PC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pc: [
        {
          photo: Bardavelidze,
          name: 'Dimitri Bardavelidze',
          position: 'Data Scientist',
        },
        {
          photo: Hull,
          name: 'Isaiah Hull',
          position: 'Senior Economist',
        },
        {
          photo: Dimitrov,
          name: 'Victor Dimitrov',
          position: 'Data Engineering & ML Practice Lead',
        },
        {
          photo: Kuzovkin,
          name: 'Ilya Kuzovkin',
          position: 'Head of Machine Learning Strategy and Research',
        },
        {
          photo: Peter,
          name: 'Olanrewaju Toluwanimi Peter',
          position: 'Data Analyst/Data Engineer',
        },
      ],
      pcHide: [
        {
          photo: Gareth,
          name: 'Billy Gareth',
          position: 'Data Science and Analytics Associate',
        },
      ],
      hide: true,
    }
    this.togglePC = this.togglePC.bind(this);
  }

  togglePC() {
    this.setState({ hide: !this.state.hide });
  }

  renderPC(item, i) {
    return (
      <div className="pc_item" key={`team-${i}`}>
        <div className="pc_img_block">
          <img className="pc_img" src={item.photo} alt={item.name} />
        </div>
        <div className="pc_info">
          <p className="pc_name">{item.name}</p>
          <p className="pc_position">{item.position}</p>
          <div className="pc_links">
            {item.fb && <a className="pc_link social_fb" target='_blank' rel='noreferrer' href={item.fb}></a>}
            {item.ln && <a className="pc_link social_ln" target='_blank' rel='noreferrer' href={item.ln}></a>}
            {item.tw && <a className="pc_link social_tw" target='_blank' rel='noreferrer' href={item.tw}></a>}
            {item.github && <a className="pc_link social_github" target='_blank' rel='noreferrer' href={item.github}></a>}
            {item.website && <a className="pc_link social_website" target='_blank' rel='noreferrer' href={item.website}></a>}
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="pc" id='pc'>
        <div className='container team_wrap'>
          <h2>Program committee</h2>
          <div className="pc_block">
            {this.state.pc.map((item, i) => this.renderPC(item, i))}
            {/* {!this.state.hide && this.state.pcHide.map((item, i) => this.renderPC(item, i))} */}
            {(!this.state.hide || window.innerWidth < 1200) && this.state.pcHide.map((item, i) => this.renderPC(item, i))}
          </div>
          <button className='pc_btn' onClick={this.togglePC}>{this.state.hide ? 'Show more' : 'Hide'}</button>
        </div>
      </div>
    )
  }
}